module.exports = __webpack_public_path__ + "static/php-0f26c0753e96388c5a99a5eb751bb317.png";